export const staticUtils: Record<string, string> = {
	flex: 'display:flex',
	'flex-row': 'display:flex;flex-direction:row',
	'flex-col': 'display:flex;flex-direction:column',
	'flex-center': 'display:flex;justify-content:center;align-items:center',
	'flex-col-center':
		'display:flex;flex-direction:column;justify-content:center;align-items:center',
	'flex-between':
		'display:flex;justify-content:space-between;align-items:center',
	'items-center': 'align-items:center',
	'items-start': 'align-items:flex-start',
	'items-end': 'align-items:flex-end',
	'items-baseline': 'align-items:baseline',
	'items-stretch': 'align-items:stretch',
	'justify-center': 'justify-content:center',
	'justify-between': 'justify-content:space-between',
	'justify-around': 'justify-content:space-around',
	'justify-end': 'justify-content:flex-end',
	'flex-1': 'flex:1',
	'flex-grow': 'flex-grow:1',
	'flex-wrap': 'flex-wrap:wrap',
	'inline-flex': 'display:inline-flex',
	grid: 'display:grid',
	relative: 'position:relative',
	absolute: 'position:absolute',
	fixed: 'position:fixed',
	'inset-0': 'top:0;left:0;right:0;bottom:0',
	'top-0': 'top:0',
	'right-0': 'right:0',
	'bottom-0': 'bottom:0',
	'left-0': 'left:0',
	'w-full': 'width:100%',
	'h-full': 'height:100%',
	'size-full': 'width:100%;height:100%',
	'max-w-none': 'max-width:none',
	'mx-auto': 'margin-left:auto;margin-right:auto',
	'ml-auto': 'margin-left:auto',
	'overflow-hidden': 'overflow:hidden',
	'overflow-visible': 'overflow:visible!important',
	'overflow-auto': 'overflow:auto',
	'overflow-x-hidden': 'overflow-x:hidden',
	'overflow-y-auto': 'overflow-y:auto',
	hidden: 'display:none',
	block: 'display:block',
	'inline-block': 'display:inline-block',
	inline: 'display:inline',
	'bg-transparent': 'background-color:transparent',
	'rounded-full': 'border-radius:9999px',
	'text-left': 'text-align:left',
	'text-center': 'text-align:center',
	'text-right': 'text-align:right',
	'font-medium': 'font-weight:500',
	'font-semibold': 'font-weight:600',
	'font-bold': 'font-weight:700',
	'cursor-help': 'cursor:help',
	'cursor-pointer': 'cursor:pointer',
	'shrink-0': 'flex-shrink:0',
	'min-w-0': 'min-width:0',
	'outline-none': 'outline:none',
	truncate: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap',
	'whitespace-nowrap': 'white-space:nowrap',
	'self-start': 'align-self:flex-start',
	'self-end': 'align-self:flex-end',
	'self-stretch': 'align-self:stretch',
	'content-stretch': 'align-content:stretch',
	'pointer-events-none': 'pointer-events:none',
	selectable: 'user-select:text',
	'box-border': 'box-sizing:border-box',
	'box-content': 'box-sizing:content-box',
	border: 'border:var(--border-width) solid var(--border)',
	'border-0': 'border:none',
	'border-t': 'border-top:var(--border-width) solid var(--border)',
	'border-t-0': 'border-top:none',
	'border-b': 'border-bottom:var(--border-width) solid var(--border)',
	'border-b-0': 'border-bottom:none',
	'border-l': 'border-left:var(--border-width) solid var(--border)',
	'border-l-0': 'border-left:none',
	'border-r': 'border-right:var(--border-width) solid var(--border)',
	'border-r-0': 'border-right:none',
	// The reset in base.sass is an unlayered `* { text-decoration: none }`, so
	// only an unlayered class rule can turn decoration back on. Generated
	// utilities are injected unlayered, which is why this lives here rather
	// than in a layered stylesheet.
	//
	// The three companion properties mirror the `a:link` rule in base.sass, so
	// a classed element underlines exactly like a link. Thickness and offset
	// come from the same tokens, which the pixel theme retunes; without them
	// the decoration falls back to the font's default hairline.
	underline:
		'text-decoration-line:underline;text-decoration-thickness:var(--link-underline-thickness);text-underline-offset:var(--link-underline-offset);text-decoration-color:var(--link-underline)'
}
